// ── Filter Options ────────────────────────────────────────────────────────────

export const NOTIFICATION_CATEGORY_FILTERS = [
  { value: "all", label: "All categories" },
  { value: "account-access", label: "Account and access" },
  { value: "driver-onboarding", label: "Driver onboarding" },
  { value: "jobs-quotes", label: "Jobs and quotes" },
  { value: "bookings", label: "Bookings" },
  { value: "job-updates", label: "Job updates" },
  { value: "payments", label: "Payments" },
  { value: "reviews-followups", label: "Reviews and follow-ups" },
  { value: "discounts-referrals", label: "Discounts and referrals" },
  { value: "admin-communications", label: "Admin communications" },
];

export const NOTIFICATION_CHANNEL_FILTERS = [
  { value: "all", label: "All channels" },
  { value: "Email", label: "Email" },
  { value: "SMS", label: "SMS" },
  { value: "Push", label: "Push" },
];

export const NOTIFICATION_HISTORY_MESSAGE_FILTERS = [
  { value: "all", label: "All messages" },
  { value: "admin-message", label: "Admin message" },
  { value: "approval-confirmation", label: "Approval confirmation" },
  { value: "booking-cancelled", label: "Booking cancelled" },
  { value: "booking-confirmation", label: "Booking confirmation" },
  { value: "booking-reassigned", label: "Booking reassigned" },
  { value: "daily-quote-summary", label: "Daily quote summary" },
  { value: "discount-expiry-reminder", label: "Discount expiry reminder" },
  { value: "discount-follow-up", label: "Discount follow-up" },
  { value: "driver-welcome", label: "Driver welcome" },
  { value: "first-quote-reminder", label: "First quote reminder" },
  { value: "password-reset", label: "Password reset" },
  { value: "password-changed", label: "Password changed" },
  { value: "phone-verification", label: "Phone verification" },
  { value: "welcome", label: "Welcome" },
  { value: "document-verification", label: "Document verification" },
  { value: "onboarding-complete", label: "Onboarding complete" },
  { value: "background-check", label: "Background check" },
  { value: "new-quote-received", label: "New quote received" },
  { value: "quote-accepted", label: "Quote accepted" },
  { value: "quote-expired", label: "Quote expired" },
  { value: "booking-reminder", label: "Booking reminder" },
  { value: "mav-on-the-way", label: "MAV on the way" },
  { value: "job-completed", label: "Job completed" },
  { value: "payment-received", label: "Payment received" },
  { value: "payout-processed", label: "Payout processed" },
  { value: "post-job-follow-up", label: "Post-job follow-up" },
  { value: "review-reminder", label: "Review reminder" },
  { value: "unused-discount-reminder", label: "Unused discount reminder" },
  { value: "referral-bonus", label: "Referral bonus" },
  { value: "policy-update", label: "Policy update" },
  { value: "account-notice", label: "Account notice" },
];

export const NOTIFICATION_STATUS_FILTERS = [
  { value: "all", label: "All statuses" },
  { value: "Delivered", label: "Delivered" },
  { value: "Delivery unconfirmed", label: "Delivery unconfirmed" },
  { value: "Failed to send", label: "Failed to send" },
];

// ── KPI Cards ─────────────────────────────────────────────────────────────────

export const NOTIFICATION_KPI_CARDS = [
  {
    label: "Total sent",
    tooltipTitle: "Total notifications sent in this period",
    value: "187",
    changePercent: "+2 (1.1%)",
    changeType: "positive",
  },
  {
    label: "Total failed to send",
    tooltipTitle: "Notifications that could not be delivered",
    value: "9",
    changePercent: "+2 (28.6%)",
    changeType: "negative",
  },
  {
    label: "Total delivered",
    tooltipTitle: "Notifications confirmed as delivered",
    value: "161",
    changePercent: "-4 (2.4%)",
    changeType: "negative",
  },
  {
    label: "Delivery rate",
    tooltipTitle: "Percentage of sent notifications that were delivered",
    value: "86.1%",
    changePercent: "-3.1 pp",
    changeType: "negative",
  },
];

// ── Category Overview Table ───────────────────────────────────────────────────

export const NOTIFICATION_CATEGORY_DATA = [
  {
    id: "account-access",
    name: "Account and access",
    sent: 24,
    channel: "Push",
    failed: 1,
    delivered: 22,
    rate: "91.7%",
    children: [
      {
        name: "Password reset",
        channel: "Email",
        sent: 7,
        failed: 0,
        delivered: 7,
        rate: "100.0%",
      },
      {
        name: "Password changed",
        channel: "Email",
        sent: 5,
        failed: 0,
        delivered: 4,
        rate: "80.0%",
      },
      {
        name: "Phone verification",
        channel: "SMS",
        sent: 5,
        failed: 1,
        delivered: 5,
        rate: "100.0%",
      },
      {
        name: "Welcome",
        channel: "Email",
        sent: 7,
        failed: 0,
        delivered: 6,
        rate: "85.7%",
      },
    ],
  },
  {
    id: "driver-onboarding",
    name: "Driver onboarding",
    sent: 18,
    failed: 2,
    delivered: 16,
    channel: "Email",
    rate: "88.9%",
    children: [
      {
        name: "Document verification",
        channel: "Email",
        sent: 8,
        failed: 1,
        delivered: 7,
        rate: "87.5%",
      },
      {
        name: "Onboarding complete",
        channel: "Push",
        sent: 6,
        failed: 1,
        delivered: 5,
        rate: "83.3%",
      },
      {
        name: "Background check",
        channel: "SMS",
        sent: 4,
        failed: 0,
        delivered: 4,
        rate: "100.0%",
      },
    ],
  },
  {
    id: "jobs-quotes",
    name: "Jobs and quotes",
    sent: 34,
    channel: "SMS",
    failed: 4,
    delivered: 28,
    rate: "82.4%",
    children: [
      {
        name: "New quote received",
        channel: "Push",
        sent: 12,
        failed: 2,
        delivered: 10,
        rate: "83.3%",
      },
      {
        name: "Quote accepted",
        channel: "Email",
        sent: 10,
        failed: 1,
        delivered: 9,
        rate: "90.0%",
      },
      {
        name: "Quote expired",
        channel: "Email",
        sent: 12,
        failed: 1,
        delivered: 9,
        rate: "75.0%",
      },
    ],
  },
  {
    id: "bookings",
    name: "Bookings",
    sent: 18,
    channel: "Push",
    failed: 0,
    delivered: 18,
    rate: "100.0%",
    children: [
      {
        name: "Booking confirmation",
        channel: "Email",
        sent: 10,
        failed: 0,
        delivered: 10,
        rate: "100.0%",
      },
      {
        name: "Booking reminder",
        channel: "SMS",
        sent: 8,
        failed: 0,
        delivered: 8,
        rate: "100.0%",
      },
    ],
  },
  {
    id: "job-updates",
    name: "Job updates",
    sent: 23,
    channel: "Email",
    failed: 0,
    delivered: 19,
    rate: "82.6%",
    children: [
      {
        name: "MAV on the way",
        channel: "Push",
        sent: 12,
        failed: 0,
        delivered: 10,
        rate: "83.3%",
      },
      {
        name: "Job completed",
        channel: "Email",
        sent: 11,
        failed: 0,
        delivered: 9,
        rate: "81.8%",
      },
    ],
  },
  {
    id: "payments",
    name: "Payments",
    sent: 11,
    channel: "Push",
    failed: 0,
    delivered: 8,
    rate: "72.7%",
    children: [
      {
        name: "Payment received",
        channel: "SMS",
        sent: 7,
        failed: 0,
        delivered: 5,
        rate: "71.4%",
      },
      {
        name: "Payout processed",
        channel: "Email",
        sent: 4,
        failed: 0,
        delivered: 3,
        rate: "75.0%",
      },
    ],
  },
  {
    id: "reviews-followups",
    name: "Reviews and follow-ups",
    sent: 17,
    failed: 0,
    channel: "Email",

    delivered: 13,
    rate: "76.5%",
    children: [
      {
        name: "Post-job follow-up",
        channel: "Email",
        sent: 11,
        failed: 0,
        delivered: 8,
        rate: "72.7%",
      },
      {
        name: "Review reminder",
        channel: "Email",
        sent: 6,
        failed: 0,
        delivered: 5,
        rate: "83.3%",
      },
    ],
  },
  {
    id: "discounts-referrals",
    name: "Discounts and referrals",
    sent: 30,
    failed: 2,
    delivered: 26,
    channel: "SMS",

    rate: "86.7%",
    children: [
      {
        name: "Unused discount reminder",
        channel: "Email",
        sent: 18,
        failed: 1,
        delivered: 16,
        rate: "88.9%",
      },
      {
        name: "Referral bonus",
        channel: "Push",
        sent: 12,
        failed: 1,
        delivered: 10,
        rate: "83.3%",
      },
    ],
  },
  {
    id: "admin-communications",
    name: "Admin communications",
    sent: 12,
    channel: "Push",
    failed: 0,
    delivered: 11,
    rate: "91.7%",
    children: [
      {
        name: "Policy update",
        channel: "Push",
        sent: 7,
        failed: 0,
        delivered: 7,
        rate: "100.0%",
      },
      {
        name: "Account notice",
        channel: "Email",
        sent: 5,
        failed: 0,
        delivered: 4,
        rate: "80.0%",
      },
    ],
  },
];

// ── Chart Data ────────────────────────────────────────────────────────────────

export const NOTIFICATION_CHART_DATA = [
  { date: "16 Sep", delivered: 26, unconfirmed: 3, failed: 2 },
  { date: "17 Sep", delivered: 27, unconfirmed: 3, failed: 1 },
  { date: "18 Sep", delivered: 24, unconfirmed: 2, failed: 2 },
  { date: "19 Sep", delivered: 29, unconfirmed: 5, failed: 1 },
  { date: "20 Sep", delivered: 25, unconfirmed: 3, failed: 2 },
  { date: "21 Sep", delivered: 27, unconfirmed: 4, failed: 1 },
  { date: "22 Sep", delivered: 16, unconfirmed: 2, failed: 1 },
];

// ── History Data ──────────────────────────────────────────────────────────────

export const NOTIFICATION_HISTORY_DATA = [
  {
    id: "1",
    date: "22 Sep 2026",
    time: "13:17",
    recipient: {
      name: "Sophia Martin",
      id: "C222E",
      initials: "SM",
      avatarColor: "#7c3aed",
      email: "sophia.martin@example.com",
    },
    categoryId: "discounts-referrals",
    category: "Discounts and referrals",
    message: "Unused discount reminder",
    channel: "Email",
    status: "Delivered",
    notificationId: "33230c3c3a9f8daf234e52cd",
    activityId: "0f57bd68c12481e60b435bfa",
    recipientType: "Driver",
    messageContent: "Your unused discount is about to expire. Use it now!",
  },
  {
    id: "2",
    date: "22 Sep 2026",
    time: "13:17",
    recipient: {
      name: "Sophia Martin",
      id: "C222E",
      initials: "SM",
      avatarColor: "#7c3aed",
      email: "sophia.martin@example.com",
    },
    categoryId: "discounts-referrals",
    category: "Discounts and referrals",
    message: "Unused discount reminder",
    channel: "Push",
    status: "Failed to send",
    errorMessage: "Push notification delivery failed; device not registered.",
    notificationId: "44340d3d4b0a9ebf245f63de",
    activityId: "1g68ce79d13592f71c544cbg",
    recipientType: "Driver",
    messageContent: "Your unused discount is about to expire. Use it now!",
    relatedRecords: {
      reviewRating: "5 out of 5",
      serviceDescription: "Premium discount package",
      route: "Premium tier",
      requestedJobDate: "22 Sep 2026",
      jobStatus: "In progress",
      serviceStatus: "Active",
      paymentStatus: "Pending",
      amount: "$45.00",
      customerName: "Sophia Martin",
      customerPhone: "+1 (555) 123-4567",
      jobId: "4f86b9ab8813b2720414af2f",
      bookingId: "BK-2026-0982",
      notes: "Customer requested priority handling. Premium package upgrade applied.",
    },
  },
  {
    id: "3",
    date: "22 Sep 2026",
    time: "12:33",
    recipient: {
      name: "John Smith",
      id: "C2222",
      initials: "JS",
      avatarColor: "#0d9488",
      email: "john.smith@example.com",
    },
    categoryId: "bookings",
    category: "Bookings",
    message: "Booking confirmation",
    channel: "Email",
    status: "Delivered",
    notificationId: "55451e4e5c1b0fch356g74ef",
    activityId: "2h79df8ae24603g82d655dch",
    recipientType: "Driver",
    messageContent: "Your booking has been confirmed. Driver will arrive in 5 minutes.",
  },
  {
    id: "4",
    date: "22 Sep 2026",
    time: "11:32",
    recipient: {
      name: "Emily Davis",
      id: "C2229",
      initials: "ED",
      avatarColor: "#0284c7",
    },
    categoryId: "reviews-followups",
    category: "Reviews and follow-ups",
    message: "Post-job follow-up",
    channel: "Email",
    status: "Delivered",
  },
  {
    id: "5",
    date: "22 Sep 2026",
    time: "11:26",
    recipient: {
      name: "Emily Davis",
      id: "C2229",
      initials: "ED",
      avatarColor: "#0284c7",
    },
    categoryId: "account-access",
    category: "Account and access",
    message: "Password reset",
    channel: "Email",
    status: "Delivered",
  },
  {
    id: "6",
    date: "22 Sep 2026",
    time: "10:45",
    recipient: {
      name: "Michael Turner",
      id: "C2230",
      initials: "MT",
      avatarColor: "#b45309",
    },
    categoryId: "jobs-quotes",
    category: "Jobs and quotes",
    message: "New quote received",
    channel: "Push",
    status: "Delivered",
  },
  {
    id: "7",
    date: "22 Sep 2026",
    time: "10:12",
    recipient: {
      name: "Sarah Connor",
      id: "C2231",
      initials: "SC",
      avatarColor: "#be123c",
    },
    categoryId: "payments",
    category: "Payments",
    message: "Payment received",
    channel: "Email",
    status: "Delivered",
  },
  {
    id: "8",
    date: "21 Sep 2026",
    time: "17:30",
    recipient: {
      name: "David Brown",
      id: "C2226",
      initials: "DB",
      avatarColor: "#4338ca",
      email: "david.brown@example.com",
    },
    categoryId: "driver-onboarding",
    category: "Driver onboarding",
    message: "Document verification",
    channel: "Email",
    status: "Failed to send",
    errorMessage: "Email send rejected; retry limit reached.",
    notificationId: "66562f5f6d2c1ghi467h85fg",
    activityId: "3i80eg9bf35714h93e766dih",
    recipientType: "Driver",
    relatedRecords: {
      reviewRating: "5 out of 5",
      serviceDescription: "One-bedroom flat move",
      route: "Camden → Islington",
      requestedJobDate: "18 Sep 2026",
      jobStatus: "Completed",
      serviceStatus: "Fulfilled",
      paymentStatus: "Completed",
      amount: "$125.50",
      customerName: "Margaret Thompson",
      customerPhone: "+1 (555) 987-6543",
      jobId: "4f86b9ab8813b2720414af2f",
      bookingId: "BK-2026-0876",
      notes: "Move completed successfully on 18 Sep. Customer satisfied with service. Document verification pending for next onboarding.",
    },
  },
  {
    id: "9",
    date: "21 Sep 2026",
    time: "15:22",
    recipient: {
      name: "Alex Kim",
      id: "C2232",
      initials: "AK",
      avatarColor: "#0d9488",
    },
    categoryId: "job-updates",
    category: "Job updates",
    message: "MAV on the way",
    channel: "Push",
    status: "Delivery unconfirmed",
  },
  {
    id: "10",
    date: "21 Sep 2026",
    time: "14:10",
    recipient: {
      name: "Priya Patel",
      id: "C2233",
      initials: "PP",
      avatarColor: "#9333ea",
    },
    categoryId: "bookings",
    category: "Bookings",
    message: "Booking reminder",
    channel: "SMS",
    status: "Delivered",
  },
  {
    id: "11",
    date: "21 Sep 2026",
    time: "09:55",
    recipient: {
      name: "James White",
      id: "C2234",
      initials: "JW",
      avatarColor: "#0369a1",
    },
    categoryId: "account-access",
    category: "Account and access",
    message: "Phone verification",
    channel: "SMS",
    status: "Delivered",
  },
  {
    id: "12",
    date: "20 Sep 2026",
    time: "16:40",
    recipient: {
      name: "Anna Lee",
      id: "C2235",
      initials: "AL",
      avatarColor: "#b91c1c",
    },
    categoryId: "reviews-followups",
    category: "Reviews and follow-ups",
    message: "Review reminder",
    channel: "Email",
    status: "Delivered",
  },
];
